export const globalPoints = {
  data: {
    pointsAmount: 244.0,
    points: [
      { amount: 22.0, expiration: "2024-04-08T13:24:21.640908Z" },
      { amount: 222.0, expiration: "2024-04-08T13:24:21.640908Z" },
    ],
  },
};

export const discountsAvailable = {
  data: [
    {
      Quantity: 10.0,
      Validity: "2024-12-31T23:59:59",
      Code: "2831702620",
    },
    {
      Quantity: 10.0,
      Validity: "2024-12-31T23:59:59",
      Code: "2858319355",
    },
    {
      Quantity: 10.0,
      Validity: "2024-12-31T23:59:59",
      Code: "654598460",
    },
  ],
};

export const pointsAvailable = {
  /*data: [
		{
			priceDiscount: 10,
			pointsNumber: 5,
			img: "https://pro.static.holabarcelona.com/images/1587/resize/296/526/5.jpg",
			validityDate: "15/06",
		},
		{
			priceDiscount: 30,
			pointsNumber: 25,
			img: "https://pro.static.holabarcelona.com/images/1587/resize/296/526/5.jpg",
			validityDate: "19/06",
		},
		{
			priceDiscount: 50,
			pointsNumber: 100,
			img: "https://pro.static.holabarcelona.com/images/1587/resize/296/526/5.jpg",
			validityDate: "24/11",
		},
	],*/

  data: {
    numPages: 1,
    definitionDataList: [
      {
        id: 148859,
        name: "Cupón descuento 5€",
        description: "5€ por cada 25 puntos",
        benefitCostData: 25.0,
        discountData: 5.0,
        endAssignmentData: "2024-12-31T23:59:59",
        endConsumptionData: "2024-12-31T23:59:59",
      },
      {
        id: 148860,
        name: "Cupón descuento 10€",
        description: "10€ por cada 45 puntos",
        benefitCostData: 45.0,
        discountData: 10.0,
        endAssignmentData: "2024-12-31T23:59:59",
        endConsumptionData: "2024-12-31T23:59:59",
      },
      {
        id: 148861,
        name: "CuponBack 10€",
        description: null,
        benefitCostData: 45.0,
        discountData: 10.0,
        endAssignmentData: "2024-12-31T23:59:59",
        endConsumptionData: "2024-12-31T23:59:59",
      },
      {
        id: 148862,
        name: "Cupon Back 30€",
        description:
          "Esta campaña es de prueba para canjear 20 puntos por 30 Euros",
        benefitCostData: 20.0,
        discountData: 30.0,
        endAssignmentData: "2024-12-31T23:59:59",
        endConsumptionData: "2025-01-31T23:59:59",
      },
    ],
  },
};

export const generatePoints = {
  data: {
    pointsAmount: 10.0,
    points: [
      {
        amount: 5.0,
        expiration: "2024-04-08T13:24:21.640908Z",
      },
      {
        amount: 222.0,
        expiration: "2024-04-08T13:24:21.640908Z",
      },
    ],
    discountUpdate: [
      {
        Quantity: 30,
        Validity: "2025-01-31T23:59:59",
        Code: "3481507756",
      },
      {
        Quantity: 30,
        Validity: "2025-01-31T23:59:59",
        Code: "704675517",
      },
      {
        Quantity: 30,
        Validity: "2025-01-31T23:59:59",
        Code: "3997971744",
      },
      {
        Quantity: 30,
        Validity: "2025-01-31T23:59:59",
        Code: "1822473600",
      },
      {
        Quantity: 30,
        Validity: "2025-01-31T23:59:59",
        Code: "3831653973",
      },
      {
        Quantity: 30,
        Validity: "2025-01-31T23:59:59",
        Code: "920776472",
      },
      {
        Quantity: 30,
        Validity: "2025-01-31T23:59:59",
        Code: "482024129",
      },
      {
        Quantity: 30,
        Validity: "2025-01-31T23:59:59",
        Code: "2562077140",
      },
      {
        Quantity: 30,
        Validity: "2025-01-31T23:59:59",
        Code: "2872527535",
      },
      {
        Quantity: 10,
        Validity: "2024-12-31T23:59:59",
        Code: "3806553855",
      },
    ],
  },
  status: 200,
};
